/*eslint no-unused-vars: "off"*/

import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "../styles/components/results.scss";
import categories from "../data/categories.json";
import results from "../data/results.json";
import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Base64 } from "../helpers/base64";
import CategoryCard from "../components/CategoryCard";
import CategoryResultModal from "../components/CategoryResultModal";
import toastr from "toastr";

import "react-circular-progressbar/dist/styles.css";
import background from "../assets/img/results-final.jpg";

const Results = ({ isLogged, postId, wpNonce, odr, mailTemplate, sourceConversion }) => {

  const [searchParams, setSearchParams] = useSearchParams();
  const [totalScore, setTotalScore] = useState(0);
  const [scores, setScores] = useState([]);
  const [modalCategory, setModalCategory] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [accepLegals, setAccepLegals] = useState(false);
  const [actionDone, setActionDone] = useState(false);
  const [confirmRegister, setConfirmRegister] = useState(false);
  const [comesFromLogin, setComesFromLogin] = useState(false);
  const [comesFromRegister, setComesFromRegister] = useState(false);

  const base_url = process.env.NODE_ENV === 'development' ? process.env.PUBLIC_URL : '/test-habitos-activia';
  const navigate = useNavigate();

  const progressStyles = {
    textColor: "#fff",
    pathColor: "#02ba44",
    trailColor: "rgba(0, 0, 0, 0.25)",
  };

  const share_text = "Activia - Descubre tu salud intestinal con este test";
  const share_url = window.location.protocol + '//' + window.location.hostname + base_url;

  const fb_share_url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURI(share_url)}&t=${share_text}`;
  const tw_share_url = `https://twitter.com/share?url=${encodeURI(share_url)}&text=${encodeURI(share_text)}`;

  /**
   * Copy URL to clipboard and show success message
   * @param {*} e
   */
  const handleShareUrl = (e) => {
    e.preventDefault();
    navigator.clipboard.writeText(window.location.href + '&sh=true');
    toastr.success("URL copiada al portapapeles");
  };


  /**
   * Handle CTA button
   * @param {*} e
   */
  const handleQuizCta = (e) => {
    e.preventDefault();

    const ghts = searchParams.get("ghts");
    const ctaUrl = 'https://activia.danone.es/reto-activia';

    if (isLogged) {
      tag(postId, 'participar', getOdrCode(totalScore));
      updateGDPR();
      //window.location.href = ctaUrl;
      //window.open(ctaUrl, '_blank');
      setActionDone(true);
    } else {

      let loginUrl = (process.env.NODE_ENV === 'development' ? 'https://danone.local/login?redirect_to=' : '/login?redirect_to=') + encodeURIComponent(window.location.href);
      loginUrl += mailTemplate ? `&mail_template=${mailTemplate}` : "";
      loginUrl += sourceConversion ? `&source_conversion=${sourceConversion}` : "";
      loginUrl += ghts ? `&ghts=${ghts}` : "";

      window.location.href = loginUrl;


      //const loginUrl = '/login?redirect_to=' + encodeURIComponent(window.location.href);
      //window.location.href = loginUrl;
    }
  };


  /**
   * Tag the ODR
   * @param {*} post_id
   * @param {*} cta
   * @param {*} odr
   */
  const tag = (post_id, cta, odr) => {
    fetch('/wp-json/danapi/v1/article/tag', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8', 'X-WP-Nonce': wpNonce },
      body: JSON.stringify({ post_id, cta, odr }),
    }).then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      } else {
        return response.json();
      }
    }).catch((error) => {
      console.log(`[Results::tag] error: `, error);
    });
  }


  /**
   * Force GDPR update
   */
  const updateGDPR = () => {
    const formData = new FormData();
    formData.append("gdpr", "Si");

    /*for (const [key, value] of formData.entries()) {
      console.log(key + ': [' + value + ']');
    }*/

    fetch('/wp-json/danapi/v1/consumer', {
      method: 'POST',
      headers: { 'X-WP-Nonce': wpNonce },
      body: formData,
    }).then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      } else {
        return response;
      }
    }).catch((error) => {
      console.log(`[Results::updateGDPR] error: `, error);
    });
  }


  /**
   * Open Threads Modal
   */
  const showModalCategory = (category) => {
    setSelectedCategory(category);
    setModalCategory(true);
  };

  /**
   * Toogle Category Results Modal
   */
  const handleModalCategory = (status) => {
    setModalCategory(status);
  };

  const handleModalAction = () => {
    setModalCategory(false);

    const ctaRef = document.querySelector('.results-actions .ght-button');
    ctaRef.scrollIntoView({ behavior: "smooth" })

    const currentColor = ctaRef.style.background;

    ctaRef.style.background = selectedCategory.color;
    setTimeout(() => {
      ctaRef.style.background = currentColor;
    }, 1000);

  };


  useEffect(() => {
    const tmpScores = [];

    // Get results from URL quesrystring
    //const ghts = "W3sia2V5IjoiYzEiLCJzY29yZSI6MTl9LHsia2V5IjoiYzIiLCJzY29yZSI6Nn0seyJrZXkiOiJjMyIsInNjb3JlIjowfSx7ImtleSI6ImM0Iiwic2NvcmUiOjV9LHsia2V5IjoiYzUiLCJzY29yZSI6MTB9LHsia2V5IjoidG90YWwiLCJzY29yZSI6NDB9XQ==";
    const ghts = searchParams.get("ghts");


    setComesFromLogin(searchParams.get("login") === "1");
    setComesFromRegister(searchParams.get("register") === "true");
    setConfirmRegister(searchParams.get("confirm") === "1");


    try {
      let totalScore = 0;

      if (ghts) {

        const questResults = JSON.parse(Base64.decode(ghts));

        // TODO: validate questResults object

        questResults.forEach((scoreItem) => {
          const category = categories.find((cat) => cat.id === scoreItem.key);
          if (category) {
            totalScore += scoreItem.score;

            if (category.showInResults) {
              scoreItem.title = category.title;
              scoreItem.color = category.color;
              scoreItem.icon = category.icon;
              scoreItem.score = Math.floor((scoreItem.score * 100) / category.maxScore);

              tmpScores.push(scoreItem);
            }
          }
        });
      }

      setTotalScore(totalScore);
    } catch (error) {
      console.error("Error parsing results:", ghts);
    }

    setScores(tmpScores);
  }, [searchParams]);


  useEffect(() => {

    if (comesFromLogin || confirmRegister || comesFromRegister) {
      const ctaRef = document.querySelector('.results-actions');
      if (ctaRef) {
        ctaRef.scrollIntoView({ behavior: "smooth" })
      }
    }
  }, [comesFromLogin, comesFromRegister, confirmRegister]);


  /**
   * Get result description based on key and score
   * @param {*} key
   * @param {*} score
   * @returns
   */
  const getResutlDescription = (key, score) => {
    const result = results.find((item) => item.key === key);
    if (result) {
      const desc = result.descriptions.find((desc) => score >= desc.min && score <= desc.max);
      return desc ? desc.text : "";
    }

    return "";
  };

  /**
   * Get ODR code based on score
   * @param {*} score
   * @returns
   */
  const getOdrCode = (score) => {
    let odrCode = `${odr}1`;

    if (score === 0 && confirmRegister) {
      odrCode = `${odr}0`;
    }

    if (score >= 50 && score < 75) {
      odrCode = `${odr}2`;
    }
    if (score > 75) {
      odrCode = `${odr}3`;
    }

    return odrCode;
  }


  return (
    <>
      <div className="results">
        <div className="results-header">
          <div className="image-wrapper">
            <img src={background} alt="Logo" />
          </div>

          {/*(confirmRegister && scores?.length === 0) &&
            <div className="results-detail">
              <div style={{ height: "200px" }}></div>
              <h2 className="results-detail__title">Test de hábitos para tu microbiota</h2>

              <h3 className="results-detail__description">Ahora que ya te has registrado, te invitamos a unirte al Reto Activia, donde encontrarás un plan creado con expertos para mejorar tus hábitos y seguir cuidando de ti, y de tu microbiota.</h3>

              <div style={{ height: "300px" }}>

                <div style={{ height: "100px" }}></div>

                {actionDone && <div style={{ height: "500px" }}>¡Gracias por apuntarte al Reto Activia! En un plazo máximo de 24h recibirás el primer correo de bienvenida con tu plan para la primera semana del Reto. ¡A por ello!</div>}

                {!actionDone &&
                  <>
                    <div className="buttons-bar">
                      <button className="ght-button" onClick={handleQuizCta} disabled={isLogged && !accepLegals}>
                        <span><strong>¡APÚNTATE AL RETO AQUÍ!</strong></span>
                      </button>
                    </div>

                    {(isLogged) ?
                      <div className="results-legals">
                        <div>
                          <input type="checkbox" id="terms" name="terms" onChange={(e) => setAccepLegals(e.target.checked)} />
                          <span>
                            Acepto las <a href="https://activia.danone.es/wp-content/uploads/2024/09/12024_07312-Bases-Legales-Sorteo-registro-Activia-challenge_20240925.pdf" target="_blank" rel="noreferrer">bases legales de esta promoción.</a>
                          </span>
                        </div>
                        <p>Al apuntarte al Reto Activia, recibirás una serie de correos electrónicos vinculados al Reto, con información relevante para tu participación y avance durante el mismo. Finalizado el reto, dejarás de recibirlos.</p>
                      </div>
                      :
                      <span>Debes iniciar sesión para participar en el reto</span>
                    }
                  </>
                }
              </div>
            </div>
          */}

          {(scores?.length > 0) &&
            <div className="results-detail">
              <h2 className="results-detail__title">Resultados generales de tu test</h2>

              <h3 className="results-detail__description" dangerouslySetInnerHTML={{ __html: getResutlDescription("overall", totalScore) }}></h3>

              <div className="results-graph">
                <CircularProgressbar value={totalScore} text={`${totalScore}%`} strokeWidth={13} styles={buildStyles(progressStyles)}></CircularProgressbar>
              </div>
            </div>
          }

        </div>


        {(scores?.length > 0) &&
          <>


            {searchParams.get("sh") === "true" ?

              //The results page is shared, so the CTA button is hidden. Show option to do de test.
              <div className="results-actions">
                <div className="buttons-bar">
                  <button className="ght-button" onClick={() => navigate(`${base_url}`)}>
                    <span>Hacer mi test</span>
                  </button>
                </div>
              </div>

              :

              // The results page is not shared
              <div className="results-actions">

                {/*searchParams.get("register") === "true" ?

                  // User came from registration page
                  <div className="results-actions__quote">Te hemos mandado un correo para que confirmes tu cuenta y poder participar en el reto. En caso de no encontrarlo, por favor revisa la bandeja de correo no deseado.</div>

                  :

                  // Show CTA button or action done message
                  <>
                    {actionDone && <div className="results-actions__quote">¡Gracias por apuntarte al Reto Activia! En un plazo máximo de 24h recibirás el primer correo de bienvenida con tu plan para la primera semana del Reto. ¡A por ello!</div>}

                    {!actionDone && <>
                      <div className="results-actions__quote">Ahora que ya {confirmRegister ? ' te has registrado' : ' tienes el resultado'}, te invitamos a unirte al Reto Activia, donde encontrarás un plan creado con expertos para mejorar tus hábitos y seguir cuidando de ti, y de tu microbiota.</div>
                      <div className="buttons-bar">
                        <button className="ght-button" onClick={handleQuizCta} disabled={isLogged && !accepLegals}>
                          <span><strong>¡APÚNTATE AL RETO AQUÍ!</strong></span>
                        </button>
                      </div>

                      {(isLogged) ?
                        <div className="results-legals">
                          <div>
                            <input type="checkbox" id="terms" name="terms" onChange={(e) => console.log(setAccepLegals(e.target.checked))} />
                            <span>
                              Acepto las <a href="https://activia.danone.es/wp-content/uploads/2024/09/12024_07312-Bases-Legales-Sorteo-registro-Activia-challenge_20240925.pdf" target="_blank" rel="noreferrer">bases legales de esta promoción.</a>
                            </span>
                          </div>
                          <p>Al apuntarte al Reto Activia, recibirás una serie de correos electrónicos vinculados al Reto, con información relevante para tu participación y avance durante el mismo. Finalizado el reto, dejarás de recibirlos.</p>
                        </div>
                        :
                        <span>Debes iniciar sesión para participar en el reto</span>
                      }
                    </>}
                  </>
                */}
              </div>
            }

            <div className="results-content">
              <h2 className="results-content__title">Resultados por categoría</h2>
              <div className="categories-wrapper">
                <div className="category-cards">
                  {scores.map((item) => (
                    <CategoryCard key={item.key} category={item} action={() => showModalCategory(item)} />
                  ))}
                </div>
              </div>


              <div className="sharer-sn">
                <span>Comparte tu resultado</span>
                <ul>
                  <li>
                    <a href={fb_share_url} target="_blank" rel="noreferrer" title="Share on Facebook"><svg viewBox="0 0 40 40" fill="none"><path d="M16.945 13.922v2.788H15v3.409h1.945V30.25h3.996V20.12h2.682s.251-1.635.373-3.423h-3.04v-2.33c0-.35.436-.818.867-.818H24V10h-2.96c-4.194 0-4.095 3.412-4.095 3.922z" fill="#3b5998"></path></svg></a>
                  </li>
                  <li>
                    <a href={tw_share_url} target="_blank" rel="noreferrer"><svg viewBox="0 0 40 40" fill="none"><path d="M22,18.8l8-9.3h-1.9l-7,8.1l-5.6-8.1H9.2l8.4,12.2l-8.4,9.8h1.9l7.3-8.5l5.9,8.5h6.4L22,18.8L22,18.8z M19.4,21.8l-0.9-1.2l-6.8-9.7h2.9l5.5,7.8l0.9,1.2l7.1,10.2h-2.9L19.4,21.8L19.4,21.8z" fill="#000"></path></svg></a>
                  </li>
                  <li>
                    <a href={window.location.href} onClick={handleShareUrl} target="_blank" rel="noreferrer"><svg viewBox="0 0 16 16" fill="none"><path d="M7.00609 8.9203C6.03382 7.94803 5.90821 6.48265 6.72697 5.66389L9.40653 2.98433C10.2253 2.16557 11.6907 2.29118 12.6629 3.26345C13.6352 4.23572 13.7608 5.70111 12.9421 6.51986L10.9696 8.49232" stroke="white" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8.4203 7.50609C9.39257 8.47837 9.51818 9.94375 8.69942 10.7625L6.01986 13.4421C5.2011 14.2608 3.73572 14.1352 2.76345 13.1629C1.79118 12.1907 1.66557 10.7253 2.48433 9.90654L4.45678 7.93408" stroke="white" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg></a>
                  </li>
                </ul>
              </div>



            </div>






            <input type="hidden" id="ght-odr" name="ght-odr" value={getOdrCode(totalScore)} />

            <CategoryResultModal
              isOpen={modalCategory}
              setIsOpen={handleModalCategory}
              handleModalAction={handleModalAction}
              category={selectedCategory}
              getResutlDescription={getResutlDescription}
            />
          </>
        }
      </div >
    </>
  );
}


export default Results
